import { EntityType } from '../../../@types/entityTypes';

const ManualDispatch: EntityType = {
  type: 'ManualDispatch',
  title: 'Manual Dispatch',
  formTitle: 'Manual Dispatch',
  formUrl: '/Sales/Order/ManualDispatch',
  screenReference: 'MANUAL_DISPATCH',
  defaultReturnUrl: '/Sales/Order/Workspace/',
};

export default ManualDispatch;
